import styled from '@emotion/styled';
import Colors from '../theme/colors';

export const Text3 = styled.span`
  color: ${Colors.text_1};
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: 133%; /* 26.6px */
  letter-spacing: -0.4px;

  @media print {
    font-size: 14px;
  }
`;
